const MAX_ZOOM_IN_FACTOR = 2;
const MAX_ZOOM_OUT_FACTOR = .5;

export default class ArenaImage {

  constructor(el) {
    this.el = el;

    if (!this.el.length) {
      return false;
    }

    this.orgWidth = this.el.width();
    this.zoomFactor = 1;

    this.svg = this.el.find('.svg-map svg');
    this.svg.find('#text').addClass('disable-text'); // block text layer from getting mouse events
    this.viewbox = this._parseViewbox(this.svg.attr('viewBox'));
    this.resize();
  }

  _parseViewbox(viewbox) {

    if (!viewbox) {
      return null;
    }

    viewbox = viewbox.split(' ');

    return {
      x: Math.round(viewbox[0]),
      y: Math.round(viewbox[1]),
      width: Math.round(viewbox[2]),
      height: Math.round(viewbox[3])
    }
  }

  zoomIn() {
    const prevZoomFactor = this.zoomFactor;
    this.zoomFactor *= 1.1;

    if(this.zoomFactor >= MAX_ZOOM_IN_FACTOR){
        this.zoomFactor = MAX_ZOOM_IN_FACTOR;
    }

    if(prevZoomFactor === this.zoomFactor){
        return false;
    }

    this.el.width(this.zoomFactor * this.orgWidth);
    this.resize();

    return true;
  }

  zoomOut() {
    const prevZoomFactor = this.zoomFactor;
    this.zoomFactor *= .9;
    
    if(this.zoomFactor <= MAX_ZOOM_OUT_FACTOR){
        this.zoomFactor = MAX_ZOOM_OUT_FACTOR;
    }

    if(prevZoomFactor === this.zoomFactor){
        return false;
    }

    this.el.width(this.zoomFactor * this.orgWidth);
    this.resize();

    return true;
  }

  resize() {

    if (!this.viewbox) {
      return false;
    }

    this.scale = this.el.width() / this.viewbox.width;
  }

  getZoomInMax() {
      return this.zoomFactor === MAX_ZOOM_IN_FACTOR;
  }

  getZoomOutMax() {
      return this.zoomFactor === MAX_ZOOM_OUT_FACTOR;
  }

  getScale() {
    return this.scale;
  }

  getWidth() {
    return this.el.width();
  }

  getHeight() {
    return this.el.height();
  }

  getSections() {
    if (this.svg) {
      const group = this.svg.find('g#Sektion');
      if (group.length) {
        return group.find('polygon, rect, path');
      }
    }

    return null;
  }

  getSvg() {
    return this.svg;
  }
}
